import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-learn-about-fixed-settlement-plans'
    backgroundVariant='lightB'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Learn About Fixed Settlement Plans
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual offers a number of fixed income plans:
        </Typography>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Interest Income Plans</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: 'Allows you to earn interest on your proceeds while keeping your principal intact.' },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Period Certain Income Plans</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: 'Allows you to receive principal and interest in monthly payments for a specified period of time.' },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Specified Amount Plans</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: 'Allows you to receive payments of principal and interest until the funds are exhausted.' },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Life Income Plans</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: 'Pay principal and interest, in equal amounts, on a monthly basis for the rest of your life.' },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <Typography
          component='h3'
          nextElement='typography'>
          Types of Interest Income Plans
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Interest Income Minimum Rates
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: <>A minimum of &#36;2,000 is required.</> },
            { bulletText: 'You can make withdrawals and transfers to another income plan at any time at no charge.' },
            { bulletText: 'The current interest rate is payable for the calendar year and may change annually, as determined by Northwestern Mutual.' },
            { bulletText: 'The interest rate will never be lower than the guaranteed rate specified in your contract.' },
            { bulletText: <>Interest is paid to you monthly, quarterly, semi&#45;annually or compounded annually.</> },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Interest Income with Guaranteed Interest Rate
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: <>A minimum of &#36;5,000 is required.</> },
            { bulletText: 'You can select from an interest period of six months, one year, two years, five years or ten years, depending on availability.' },
            { bulletText: 'At the end of the interest period, your choice will renew automatically, unless you specify otherwise. The rate of interest will be that offered by Northwestern Mutual at that time.' },
            { bulletText: <>Interest is paid to you monthly, quarterly, semi&#45;annually, or compounded annually</> },
            { bulletText: 'You can make withdrawals and transfers at the end of the interest period you select. A charge will be deducted, however, if you make a withdrawal or transfer before the end of your interest period.' },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Types of Period Certain Income Plans
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Period Certain for Specified Period
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: <>A minimum of &#36;2,000 is required.</> },
            { bulletText: 'Principal and interest in varying monthly payments over a specified period between 1 and 30 years.' },
            { bulletText: 'The current interest rate is payable for the calendar year and may change annually, as determined by Northwestern Mutual.' },
            { bulletText: 'It will never be lower than the guaranteed minimum rate specified in your contract.' },
            { bulletText: 'Interest that exceeds your guaranteed rate will be added to your guaranteed payments.' },
            { bulletText: 'A withdrawal or transfer of the remaining funds can be made free of charge at any time before the end of your payment period. Partial withdrawals are not allowed.' },

          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Period Certain for Specified Period with Guaranteed Interest Rate
        </Typography>
        <Typography nextElement='typography'>
          The Period Certain for Specified Period with Guaranteed Interest Rate option includes the
          following:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: <>A minimum of &#36;5,000 is required.</> },
            { bulletText: 'You receive principal and interest in equal monthly payments guaranteed for a specified period of 2 to 20 years.' },
            { bulletText: 'The interest rate and the payment amount are both guaranteed for the time period you select.' },
            { bulletText: 'A full withdrawal or transfer can be made at any time. A charge will be deducted, however, if you make a withdrawal or transfer before the end of the period.' },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Types of Specified Amount Plan
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Specified Amount Plan
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Principal and interest are paid to you in an amount you choose until your account balance is zero.' },
            { bulletText: 'Payments continue until all interest and principal have been paid out.' },
            { bulletText: 'The current interest rate is payable for the calendar year, and may change annually, as determined by Northwestern Mutual.' },
            { bulletText: 'It will never be lower than the guaranteed minimum rate specified in your contract.' },
            { bulletText: 'Interest that exceeds your guaranteed rate will be used to extend your payment period.' },
            { bulletText: 'Withdrawals or transfers of your remaining funds can be made free of charge.' },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Life Income Plans
        </Typography>
        <Typography>
          Northwestern Mutual has life income plans with two payment options. For either case, withdrawals or transfers are not allowed once payments have started.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Lifetime Only Plans
        </Typography>
        <Typography>
          Guarantees payments for life. Payments stop upon your death.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Lifetime with a Certain Period Plan
        </Typography>
        <Typography>
          Guarantees payments for life. You have the option of guaranteed payments for 10 or 20 years, or until all of the amount you originally invested is paid out. If you die before the guaranteed payment period ends, payments will continue to your beneficiary for the remainder of the guaranteed period.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Joint & Survivor Life Income Plans
        </Typography>
        <Typography>
          Northwestern Mutual has Joint &#38; Survivor Life Income Plans that provide a monthly payment based on the lifetimes of two people.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Joint Life 100&#37; to Survivor &#40;full amount to survivor&#41;
        </Typography>
        <Typography>
          Receive guaranteed payments for your lifetime, the lifetime of the joint annuitant, or for the period you choose, whichever is latest. Upon the death of the first to die, the payments continue and are payable to the survivor. Income plan transfers or withdrawals are not available.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Joint Life with Two&#45;Thirds to Survivor
        </Typography>
        <Typography>
          Receive guaranteed payments for your lifetime or the lifetime of the joint annuitant for the period you choose, whichever is latest. Upon the death of the first to die, payments reduce to two-thirds &#40;2&#47;3&#41; of the payment and are payable to the survivor. Income plan transfers and withdrawals are not available.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Joint Life with One&#45;Half to Survivor
        </Typography>
        <Typography>
          Receive guaranteed payments for your lifetime or the lifetime of the joint annuitant for the period you choose, whichever is latest. Upon the death of the first to die, the payments reduce to one&#45;half &#40;1&#47;2&#41; of the payment and are payable to the survivor. Income plan transfers or withdrawals are not available.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Joint Life with Two&#45;Thirds to Joint Annuitant
        </Typography>
        <Typography>
          Receive guaranteed payments for your lifetime or the lifetime of the joint annuitant for the period you choose, whichever is latest. Upon the death of the first to die, payments reduce to two&#45;thirds &#40;2&#47;3&#41; of the payment and are payable to the joint annuitant if living, otherwise to the contingent beneficiary for the balance of the period you chose. Income plan transfers or withdrawals are not available.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Joint Life with One&#45;Half to Joint Annuitant
        </Typography>
        <Typography>
          Receive guaranteed payments for your lifetime or the lifetime of the joint annuitant for the period you choose, whichever is latest. Upon the death of the first to die, payments reduce to one&#45;half &#40;1&#47;2&#41; of the payment and are payable to the joint annuitant if living, otherwise to the contingent beneficiary for the balance of the period you chose. Income plan transfers or withdrawals are not available.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Who To Consult
        </Typography>
        <Typography disableBottomPadding>
          Decisions concerning a fixed income plan should be made within the scope of your total financial situation, your tolerance of investment risk and return potential, and with the guidance of your representative or tax advisor.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
